import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsListService } from '../forms-list/forms-list.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-move-templates',
  templateUrl: './move-templates.component.html',
  styleUrls: ['./move-templates.component.scss']
})
export class MoveTemplatesComponent implements OnInit {

  collections: any = [];
  filteredCollections: any = [];
  template: any = {};
  collectionId: string = "";
  searchText: string = "";

  constructor(
    public activeModal: NgbActiveModal,
    private _templateService: FormsListService
  ) { }

  ngOnInit() {
    this.filteredCollections = [...this.collections];
    this.filteredCollections = _.filter(this.filteredCollections, (collection) => {
      if(collection._id != this.collectionId) {
        return true;
      }
    })
  }

  moveTemplate(collectionId: string, collectionName: string) {
    let req = {
      templateId: this.template._id,
      directory: {
        _id: collectionId,
        name: collectionName
      }
    }

    this._templateService.addExistingTemplates(req).subscribe((response: any) => {
      if(response['status']) {
        this.template['directory'] = {
          _id: collectionId,
          name: collectionName
        }

        if(_.isEmpty(collectionId)) {
          delete this.template.directory;
        } else {
          this.template.directoy = {
            _id: collectionId,
            name: collectionName
          }
        }
        this.activeModal.close({template: this.template, destination: collectionId});
      }
    })
  }

  filterCollections(value: string) {
    this.filteredCollections = this.collections.filter((obj: any) =>
      JSON.stringify(obj.name).toLowerCase().includes(value)
    )
    this.filteredCollections = _.filter(this.filteredCollections, (collection) => {
      if(collection._id != this.collectionId) {
        return true;
      }
    })
  }

  close() {
    this.activeModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/app/move-templates/move-templates.component.ts